export default __webpack_public_path__ + "static/media/ICE_HEAD.b1c607e1.png";